import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { Box, Divider as BaseDivider } from '../../Base';
import { SPACE } from '../../Theme';
import QuizSimple from '../../QuizSimple';

const Divider = (props) => <BaseDivider borderColor="#dedede" {...props} />;

const quizDataMapping = (quizData = {}) => {
  const { id, type, title, solution = {}, choices = [], fillInTheBlankItems = [] } = quizData;
  const result = {
    id,
    type,
    title,
    solution: get(solution, 'value'),
    choices: choices?.map((choice, index) => ({
      id: `${id}-${index}`,
      value: choice.value,
      isAnswer: choice.isAnswer,
      hint: choice.hint,
    })),
    fillInTheBlankItems,
  };
  return result;
};

class QuizBox extends Component {
  static propTypes = {
    id: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object),
    onCompleted: PropTypes.func,
    userAssetDocument: PropTypes.shape({
      userAnswers: PropTypes.arrayOf(
        PropTypes.shape({ id: PropTypes.string, value: PropTypes.string })
      ),
    }),
    onUpdateUserAssetData: PropTypes.func,
  };

  static defaultProps = {
    items: [],
    onCompleted: () => {},
  };

  state = {
    answeredQuizIndex: {},
  };

  handleAnswerQuiz = (index, isCorrect, answeredChoiceIndex, isFillInTheBlankQuiz) => {
    const { answeredQuizIndex } = this.state;
    const newAnswerQuizIndex = { ...answeredQuizIndex, [index]: isCorrect };
    this.setState({ answeredQuizIndex: newAnswerQuizIndex }, () => {
      if (Object.keys(this.state.answeredQuizIndex).length === this.props.items.length) {
        this.props.onCompleted();
      }
    });
    // TODO: FILL_IN_THE_BLANK is not support tracking user’s answers
    if (!isFillInTheBlankQuiz) {
      this.props.onUpdateQuizSimpleResult(index, isCorrect, answeredChoiceIndex);
    }
  };

  render() {
    const { id, items, userAssetDocument, onUpdateUserAssetData } = this.props;

    return (
      <Fragment>
        {items.map((quiz, index) => (
          <Box key={`${id}-${quiz.id}`} mb={SPACE.xxl}>
            <QuizSimple
              key={`${id}-${quiz.id}`} // using key for rerendering quiz when question change
              question={quizDataMapping(quiz)}
              currentQuestionNumber={index + 1}
              onAnswerQuiz={(isCorrect, answeredChoiceIndex, isFillInTheBlankQuiz) =>
                this.handleAnswerQuiz(index, isCorrect, answeredChoiceIndex, isFillInTheBlankQuiz)
              }
              userAssetDocument={userAssetDocument}
              onUpdateUserAssetData={onUpdateUserAssetData}
            />
            <Divider />
          </Box>
        ))}
      </Fragment>
    );
  }
}

export default QuizBox;
